import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@components/Typography';
import Drawer from '@components/Drawer';
import { UserIcon } from 'assets/images/icons';

export const StyledDrawer = styled(Drawer)({
    '& .drawer-content': {
        padding: '0 24px',
        minHeight: 0,
    },
});

export const Content = styled('div')({
    height: '100%',
    overflowY: 'auto',
});

export const StyledIconButton = styled(IconButton)({
    position: 'relative',
    height: 24,
    width: 24,
    padding: 2,
    '& svg': {
        width: 24,
        height: 24,
    },
});

export const Badge = styled(Typography)({
    height: 12,
    width: 12,
    fontSize: '6px !important',
    lineHeight: '6px',
    position: 'absolute',
    top: 0,
    right: 0,
    color: '#fff',
    backgroundColor: 'var(--error-main)',
    padding: '2px 6px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const CssRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: 'var(--primary-main)',
    },
});

export const StyledUserIcon = styled(UserIcon)({
    width: '18px !important',
    height: '18px !important',
    '& path': {
        fill: 'var(--text-tertiary)',
        fillOpacity: 1,
    },
});

export const CardWrapper = styled('div')({
    marginBottom: '8px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    padding: '16px',
    '&:nth-of-type(1)': {
        marginTop: '24px',
    },
    '&:nth-last-of-type(1)': {
        marginBottom: '24px',
    },
    '&:hover': {
        borderColor: 'var(--primary-main)',
    },
});

export const ContentWrapper = styled('div')({
    display: 'grid',
    gridGap: '8px',
    width: '100%',
    gridTemplateColumns: '40px auto',
    cursor: 'pointer',
});

export const IconWrapper = styled('span')({
    '& svg': {
        transform: 'translateY(0)',
    },
    '& svg path': {
        fill: 'var(--primary-main)',
        fillOpacity: 1,
    },
});
